export function cleanFont(s = '') {
    return s.toLowerCase().trim().replace(/"/g, '').replace(/'/g, '');
}
//# sourceMappingURL=clean-font.js.map